<template>
  <div class="finances-report">
    <div class="finances-report__header">
      <p>Defina el período y los criterios para generar su reporte</p>
    </div>

    <div class="finances-report__body">
      <!-- Fila 1 -->
      <div class="finances-report__grid">
        <!-- Fecha Inicio -->
        <div class="finances-report__date">
          <span class="finances-report__label">Fecha de inicio del servicio</span>
          <date-picker
            class="finances-report__field"
            type="date"
            value-type="format"
            :keys="{ value: 'id', label: 'name' }"
            @close="handleOpenChange"
            placeholder="Fecha Inicio Servicio"
            :input-attr="{ 'aria-label': 'Fecha de inicio del servicio' }"
            v-model="filtroFechaInicio"
          />
        </div>

        <!-- Fecha Término -->
        <div class="finances-report__date">
          <span class="finances-report__label">Fecha de término del servicio</span>
          <date-picker
            class="finances-report__field"
            type="date"
            value-type="format"
            format="YYYY-MM-DD"
            :keys="{ value: 'id', label: 'name' }"
            @close="handleOpenChange"
            placeholder="Fecha Término Servicio"
            :input-attr="{ 'aria-label': 'Fecha de término del servicio' }"
            v-model="filtroFechaTermino"
          />
        </div>
        <!-- Cliente -->
        <ui-select
          class="finances-report__field"
          has-search
          label="Cliente"
          :options="listaClientesUsuarioActual"
          placeholder="Seleccionar"
          searchPlaceholder="Buscar"
          :keys="{ value: 'id', label: 'name' }"
          v-model="filtroCliente">
        </ui-select>

        <!-- Nave -->
        <ui-select
          class="finances-report__field"
          has-search
          label="Nave"
          :options="naves"
          placeholder="Seleccionar"
          searchPlaceholder="Buscar"
          :keys="{ value: 'id', label: 'name' }"
          v-model="filtroNave">
        </ui-select>

        <!-- Naviera -->
        <ui-select
          class="finances-report__field"
          has-search
          label="Naviera"
          :options="navieras"
          placeholder="Seleccionar"
          :keys="{ value: 'id', label: 'name' }"
          v-model="filtroNaviera">
        </ui-select>

        <!-- POD -->
        <ui-select
          class="finances-report__field"
          has-search
          label="POD"
          :options="puertos"
          placeholder="Seleccionar"
          searchPlaceholder="Buscar"
          :keys="{ value: 'id', label: 'name' }"
          v-model="filtroPod">
        </ui-select>

        <ui-select
          class="finances-report__field"
          has-search
          label="Proveedores"
          :options="lista_proveedores"
          placeholder="Seleccionar"
          searchPlaceholder="Buscar"
          :keys="{ value: 'id', label: 'name' }"
          v-model="filtroProveedor">
        </ui-select>

        <!-- Estado de facturación -->
        <ui-select
          class="finances-report__field"
          label="Facturación"
          :options="opcionesFacturacion"
          :keys="{ value: 'id', label: 'name' }"
          v-model="invoiceStatusFilter">
        </ui-select>
      </div>

      <!-- Footer -->
      <p class="finances-report__note">
        <i class="fa fa-envelope-o" aria-hidden="true"></i>
        El reporte se enviará a su correo electrónico
      </p>
      <div class="finances-report__footer">
        <button
          type="button"
          class="finances-report__button finances-report__button--secondary finances-report__button--clear"
          @click="clearFilters">
          <i class="fa fa-eraser" aria-hidden="true"></i> Limpiar filtros
        </button>
        <button
          type="button"
          class="finances-report__button finances-report__button--red"
          @click="handleSubmit">
          <i class="fa fa-download" aria-hidden="true"></i> Generar reporte
          finanzas
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import UiSelect from "keen-ui/src/UiSelect";
import DatePicker from "vue2-datepicker";
import { mapState } from "vuex";
import VueToastify from "vue-toastify";
import "vue2-datepicker/locale/es";
import "vue2-datepicker/index.css";
import uuid from "keen-ui/src/helpers/uuid";
import { generarReporteFinanzasEC } from "@/constants/serviciosLogisticos";

Vue.use(VueToastify);

export default {
  data() {
    return {
      filtroFechaInicio: "",
      filtroFechaTermino: "",
      filtroCliente: "",
      filtroNave: "",
      filtroNaviera: "",
      filtroPod: "",
      filtroProveedor: "",
      invoiceStatusFilter: { id: null, name: "Todos" },
      opcionesFacturacion: [
        { id: null, name: "Todos" },
        { id: 1, name: "Facturado" },
        { id: 0, name: "Sin facturar" }
      ]
    };
  },
  components: {
    UiSelect,
    // UiTextbox,
    DatePicker
  },
  computed: {

    ...mapState([
      "navieras",
      "listaClientesUsuarioActual",
      "puertos",
      "naves",
      "lista_proveedores"
    ]),

  },
  methods: {

    clearFilters() {
      this.filtroFechaInicio = "";
      this.filtroFechaTermino = "";
      this.filtroCliente = "";
      this.filtroNave = "";
      this.filtroNaviera = "";
      this.filtroPod = "";
      this.filtroProveedor = "";
      this.invoiceStatusFilter = this.opcionesFacturacion[0];
    },


    handleOpenChange() {
      this.showTimePanel = false;
    },

    async handleSubmit() {

      this.$vToastify.loader("Solicitando reporte...");

      const filters = {
        fechaInicio: this.filtroFechaInicio,
        fechaTermino: this.filtroFechaTermino,
        cliente: this.filtroCliente.id ?? null,
        nave: this.filtroNave.name ?? null,
        naviera: this.filtroNaviera.id ?? null,
        pod: this.filtroPod.id ?? null,
        proveedor: this.filtroProveedor.id ?? null,
        isInvoiced: this.invoiceStatusFilter.id ?? null,
      };

      const { status, message } = await generarReporteFinanzasEC(filters, uuid.short("reporte-finanzas-"));

      this.$vToastify.stopLoader();

      if (status === 200) {

        this.$vToastify.success("En unos minutos recibirá el reporte en su correo electrónico", message);

      } else {

        this.$vToastify.success("Intente nuevamente por favor", message);

      }

    }
  }
};
</script>

<style src="@/assets/css/finances-report.css"></style>
